export default class CONST {
  static EXTRA_DOMAIN_NAME = "imts.eastcoast-nsa.gov.tw"
  static EXTRA_IP_DOMAIN_NAME = "61.222.211.44"
  static VPN_DOMAIN_NAME = "192.168.1.1"
  static BACKUP_IP = "10.179.3.10"
  static ACTIVITY_CLOUD_DOMAIN = "moonseafestival.iisi-isurveillance.com" //月光海 Domain


  static MULTI_SELECT_ALL = 'select_all'


  static REFRESH_DAT_TIMER_MIN = 1000 * 60 * 1 // 一分鐘
  static REFRESH_DAT_TIMER_SEC = 1000 * 1  // 一分鐘
  // static REFRESH_DAT_TIMER_MIN = 1000 * 60 * 10 // 十分鐘
  // static REFRESH_DAT_TIMER_SEC = 1000 * 1  * 600 // 十分鐘

  static ELK_SEARCH_MAX_SIZE = 10000

  static SCENIC_AREA_ID = 'scenicAreaId'
  static SCENIC_AREA_NAME = 'scenicAreaName'
  static PUBLIC_PLACE_ID = 'publicPlaceId'
  static PUBLIC_PLACE= 'publicPlace'
  static TOILETS = 'toilets'

  static HUMIDITY = 'humidity'
  static TEMPERATURE = 'temperature'
  static HANDS_ANITIZER_DETECTORS = 'handsanitizerdetectors'
  static ODOR = 'odor'

  static MJPEG_DEVICE_ID = ['cv00001', 'cv00002', 'cv00003', 'cv00004']
  static PLAYER_TYPE = {
    MJPEG: 'MjpegPlayer',
    FLV: 'FlvPlayer'
  }

  static SCENIC_AREA_ADDITION_INFO_ENUM = {
    // google: Enum flags in JavaScript -stack overflow
    NONE : 0,
    CAR_FLOW: 1, //車流 (事件: 容留上限)
    PEOPLE_ANALYZE: 2,  // 人流 
    WEATHER_INFO: 4, //天氣 (事件:警特報)
    CLOSE_IN_ADVANCE: 8, //管制  (事件:警特報)
    TOILET_PEOPLE_FLOW: 16,
    PROVIDER_TOILET_DEVICE: 32, //公廁維運 (事件: 公廁維護)
    VIOLATION: 64, // 違規 (事件: 違規)
    SOS: 128, //(事件: 緊急求救)
    EINK_DISPLAY: 256, //(電子紙)
    HUMAN_SENSOR: 512, //(人體感測)
    SMART_WATER_METER: 1024, //(智慧水表)
    SMART_ELECRTIC_METER: 2048, //(智慧電表)
  }


  static SCENIC_AREA_EVENT_INFO = [
    {enumType: 'all', id: 0, description: '全部',column:['地點','事件種類','時間','狀態']},
    {enumType: 'emergencyEvent', id: 1, description: '緊急求救',column:['地點','時間','狀態']},
    {enumType: 'parkingLimit', id: 2, description: '容留上限',column:['地點','時間','狀態']},
    {enumType: 'violation', id: 3, description: '違規',column:['地點','時間','狀態']},
    {enumType: 'disaster', id: 4, description: '天氣風險',column:['地點','時間','狀態']},
    {enumType: 'toliet', id:5, description: '公廁維運',column:['地點','時間','狀態']},
    {enumType: 'control', id:6, description: '管制',column:['地點','操作時間','狀態']},
    {enumType: 'device', id:7, description: '設備',column:['地點','時間','狀態']},
  ]


  static IMG_MAX_WIDTH = 1024;
  static IMG_MAX_HEIGHT = 576;
  //---------  VD start
  static VD_KEY_VEHICLE_TYPE = 'VehicleType'
  static VD_KEY_VOLUME_TYPE = 'Volume'
  static VD_ID = {
    NORTH: 'northVD',
    MIDDLE: 'middleVD',
    SOUTH: 'southVD'
  }
  static VD_VEHICLE_TYPE = {
    M: 'M', //機車
    S: 'S', //小型車
    L: 'L', //大型車
    T: 'T', //聯結車
  }
  static VD_LINK_TYPE = {
    IN: 'in',
    OUT: 'out'
  }
  static VD_INIT_DATA = {
    M: 0,
    S: 0,
    L: 0,
    T: 0
  }
  //---------  VD end

  //--------- Sanxian weather station start
  static WEATHER_TYPE_KEY = {
    HUMIDITY: 'Humidity',
    RAIN: 'Rain',
    TEMP: 'Temperature',
    WIND_DIRECT: 'WindDirection',
    WIND_SPEED: 'WindSpeed'
  }
  //--------- Sanxian weather station end

  //---------  cctv type in map start
  static MAP_ICON_TYPE = {
    IISI: 'iisi',
    IISI_DISABLE: 'iisi-disable',
    TRFFIC: 'traffic',
    WEATHER: 'weather',
    ODOR: this.ODOR,
    HAND: this.HANDS_ANITIZER_DETECTORS,
    EMERGENCY: 'emergency'
  }

  static TRAFFIC_CCTV_KEY = {
    CCTVID: 'CCTVID',
    CENTER: 'center',
    LAT: 'lat',
    LNG: 'lng',
    URL: 'streamUrl',
    NAME: 'name',
    ID: 'id',
    TYPE: 'type'
  }
  //---------  cctv type in map end

  //---------  ELK search type
  static ELK_TYPE = {
    TYPE_OBJECT_DETECTION: 'objectdetection',
    TYPE_VEHICLE_PLATE: 'vehicleplate'
  }
  //---------  ELK search type end

  //---------  eastCoast device data type start
  static EAST_COAST_DEVICE_TYPE = {
    VIDEO_CAMERA: 'videoCamera',
    LOUD_SPEAKER: 'loudSpeaker',
    CALL_HELP_SINK: 'callHelpSink',
    HAND_SANITIZER_DETECTOR: 'handSanitizerDetector',
    PECULIAR_SMELL_DETETOR: 'peculiarSmellDetector',
    LED_DISPLAY: 'ledDisplay',
    THEREMOMETER_DETECTOR: 'thermometerDetector',
    OTHERS: 'others',
    SMART_WATER_METER: 'smartWaterMeter',
    SMART_ELECTRIC_METER: 'smartElectricMeter',
    HUMAN_SENSOR: 'humanSensor',
    EINK_DISPLAY: 'eInkDisplay',

  }
  static EAST_COAST_DEVICE_TYPE_ENUM = {
    videoCamera: '攝影機',
    loudSpeaker: '喇叭',
    callHelpSink: '對講機',
    handSanitizerDetector: '給皂機',
    peculiarSmellDetector: '異味偵測',
    ledDisplay: '字幕機',
    thermometerDetector: '温濕度感測器',
    others: '其他',
    smartWaterMeter: '智慧水表',
    smartElectricMeter: '智慧電表',
    humanSensor: '人體感測器',
    eInkDisplay: '電子紙',
  }

  static EAST_COAST_DEVICE_IOT_TYPE=[
    //公廁維運事件種類 (目前僅顯示氣味偵測異常與給皂機事件)
    {enumType: 'nilometer',description:'給皂機',id:1},
    {enumType: 'odor',description:'異味偵測',id:2},
    // {enumType: 'temperature',description:'溫度感測',id:3},
    // {enumType: 'humidity',description:'濕度感測',id:4},
    
  ]
  //DEVICE 的各式 error code
  static DEVICE_ERROR_CODE = {
    DAILY_CHECK_ERROR:"8",
  }

  //value為暫定，目前後端還沒用到，只有斷線
  static DEVICE_ERROR_TYPE={
    disconnected:{value:1,description:'斷線'},
    malfunction:{value:2,description:'異常'}
  }

  static DEVICE_CONNECT_STATUS={
    ALL: {enumType: 'all', description:'全部'},
    CONNECT: {enumType: 'connect', description:'連線'},
    DISCONNECT: {enumType: 'disconnect', description:'斷線'},
  }

  //---------  eastCoast device data type end

   //--------- eastCoast device disable Status start
   static DEVICE_DISABLE_STATUS = {
    ALL: {enumType: 'all', description:'全部'},
    DISABLE: {enumType: 'disabled', description:'停用'},
  }
  //--------- eastCoast device disable Status end

  //--------- eastCoast device dialog mode start
  static DIALOG_MODE = {
    VIEW: 'view',
    ADD_DEVICE: 'add_device',
    EDIT_DEVICE: 'edit_device',
    DELETE: 'delete'
  }
  //--------- eastCoast device dialog mode end

  //---------  eastCoast public place data type start 
  // static EAST_COAST_PUBLIC_PLACE_TYPE = {
  //   UNKNOW: 'unKnown',
  //   ENTRACE: 'entrance',
  //   PARKING_AREA: 'parkingArea',
  //   TOILET: 'toilet',
  //   OTHER: 'other'
  // }

  static EAST_COAST_PUBLIC_PLACE_TYPE = [
    //未知與遊客中心分類已暫停使用
    // {enumType: 'unKnown',description:"未知"},
    {enumType: 'entrance',description:"入口"},
    {enumType: 'parkingArea',description:"停車場"},
    {enumType: 'toilet',description:"廁所"},
    // {enumType: 'center',description:"遊客中心"},
    {enumType: 'other',description:"其他"}
  ]

  static EAST_COAST_PUBLIC_PLACE_KEY = {
    SCENIC_AREA_ID: this.SCENIC_AREA_ID
  }
  //---------  eastCoast public place data type end

  //---------  videoPurposeType  start
  static VIDEO_PURPOSE_TYPE = {
    NONE: 'none',
    TOILET_PERSON_FLOW: 'toiletPersonFlow',
    INTRUDE: 'intrude',
    CLOSE_IN_ADVANCE: 'closeInAdvance',
    VEHICLE_IN: 'vehicleIn',
    VEHICLE_OUT: 'vehicleOut',
    PERSON_ATTRIBUTE: 'personAttributeAnalyze',
    CENTER_PEOPLE_PERSONFLOW: 'centerPersonFlow'
  }

  static VIDEO_PURPOSE_TYPE_CHINESE = { // key需要與VIDEO_PURPOSE_TYPE的value一樣
    none: '無',
    toiletPersonFlow: '廁所人流',
    intrude: '機車闖入',
    closeInAdvance: '預警封閉',
    vehicleIn: '車輛進入',
    vehicleOut: '車輛離開',
    personAttributeAnalyze: '人流屬性分析',
    centerPersonFlow: '遊客中心人流'
  }
  //---------  videoPurposeType  end

  //--------- elk car type start
  static CAR_TYPE = {
    MOTO: 'motorbike',
    CAR: 'car',
    SMALLBUS: 'smallbus',
    BUS: 'bus',
    TRUCK: 'truck'
  }
  static ELK_CAR_TYPE = {
    car: '小型車',
    smallbus: '小巴士',
    truck: '卡車',
    bus: '大巴士',
    motorbike: '機車'
  }

  static ELK_CAR_TYPE_TO_TOURISM = {
    //將ELK車種轉換為觀光署車種
    car: '小型車',
    smallbus: '大型車',
    truck: '小型車',
    bus: '大型車',
    motorbike: '機車'
  }

  // static ELK_CAR_TYPE_TO_TOURISM = {
  //   '小型車': ['car', 'truck'], 
  //   '大型車': ['smallbus', 'bus'], 
  //   '機車': ['motorbike']
  // };


  static CSV_TYPE_MONTH_TOUR = 'monthTour'
  static CSV_TYPE_MONTH = 'month'
  static DISSMISS_CARTYPE_LENGTH = 2 // 觀光署只需要機車 小客車 大巴士
  static ELK_CAR_TYPE_ENUM = [ //產生報表用，順序不可調換，後面兩種車型觀光署月報不顯示
    {enumType: this.CAR_TYPE.MOTO, estimateCarType:'motorcycle', description:'機車', weight: 1.2, holidayWeight: 1.2},
    {enumType: this.CAR_TYPE.CAR, estimateCarType:'compact', description:'小型車', weight: 2, holidayWeight: 2},
    {enumType: this.CAR_TYPE.BUS, estimateCarType:'fullSize', description:'大巴士', weight: 29, holidayWeight: 30},
    {enumType: this.CAR_TYPE.SMALLBUS, estimateCarType:'smallBus', description:'小巴士', weight: 29, holidayWeight: 30},
    {enumType: this.CAR_TYPE.TRUCK, estimateCarType:'truck', description:'卡車', weight: 2.4, holidayWeight: 2.4},
  ]
  //--------- elk car type start

  //--------- EastCoastMonitor cwb weather start
  static HOME_PAGE_WEATHER_ITEM = {   //conditionType 基本表示小寫，人愷5000 api 是大寫
    SCENIC_AREA_ID: this.SCENIC_AREA_ID,
    WEATHER: 'weather',
    TEMP: this.TEMPERATURE,
    RAIN_FALL: 'rainFall',
    HUMIDITY: this.HUMIDITY,
    WIND_VELOCITY: 'windVelocity',
    WIND_POWER: 'windPower',
    GUST: 'gust',
    WAVE: 'wave',
    SWELL: 'swell',
    EARTHQUAKE: 'earthquake',
    TYPHOON: 'typhoon',
    HEAVY_RAIN: 'heavyRain',
    WATER_LEVEL: 'waterLevel',
    RAIN_FALL: 'rainfall',
  }

  static INFORM_SETTING_WETHER_ITEM = [
    {enumType: this.HOME_PAGE_WEATHER_ITEM.WIND_POWER, description: '風力', unitTitle: '通報級數', },
    {enumType: this.HOME_PAGE_WEATHER_ITEM.GUST, description: '陣風', unitTitle: '通報級數', },
    {enumType: this.HOME_PAGE_WEATHER_ITEM.WAVE, description: '浪高', unitTitle: '通報浪高(公尺)', },
    {enumType: this.HOME_PAGE_WEATHER_ITEM.SWELL , description: '長浪', unitTitle: '', },
    {enumType: this.HOME_PAGE_WEATHER_ITEM.EARTHQUAKE, description: '地震', unitTitle: '',},
    {enumType: this.HOME_PAGE_WEATHER_ITEM.TYPHOON, description: '颱風', unitTitle: '',},
    {enumType: this.HOME_PAGE_WEATHER_ITEM.HEAVY_RAIN, description: '豪雨', unitTitle: '',},
    {enumType: this.HOME_PAGE_WEATHER_ITEM.WATER_LEVEL, description: '水位', unitTitle: '通報水位(公尺)',},
    // {enumType: this.HOME_PAGE_WEATHER_ITEM.RAIN_FALL, description: '雨量', unitTitle: '通報雨量(毫米)',},
  ]

  static CWB_DISASTER_SETTING = [
    {enumType: 'WindPower', description: '風力', id: 6, alert:6, danger:8},
    {enumType: 'Gust', description: '陣風', id: 7, alert:8, danger:10},
    {enumType: 'Wave', description: '浪高', id: 8, alert:1.5, danger:3},
    {enumType: 'Swell', description: '長浪', id: 9, normal:'低於警戒', danger: ''},
    {enumType: 'Earthquake', description: '地震', id: 10, normal:0, danger: ''},
    {enumType: 'Typhoon', description: '颱風', id: 11, normal:'解除颱風警報', danger: ''},
    {enumType: 'heavyRain', description: '豪雨', id: 12, normal:0, alert:2, danger: 3},  //"", "大雨", "豪雨", "大豪雨", "超大豪雨","陸上強風", "海上強風" (先用字數判斷)
  ]

  static CLIMATE_TYPE_ENUM = {
    UNKNOW: {enumType: 'unKnow',description:'未知', id: 0, unit: ''},
    WEATHER: {enumType: 'weather', description: '天氣', id: 1, unit: ''},
    TEMPERATURE: {enumType: 'temperature', description: '溫度', id: 2, unit: '℃'},
    RAIN_FALL: {enumType: 'rainFall', description: '雨量', id: 3, unit: 'mm'},
    HUMIDITY: {enumType: 'humidity', description: '濕度', id: 4, unit: '%'},
    WIND_VELOCITY: {enumType: 'windVelocity', description: '風速', id: 5, unit: 'm/s'},
    WIND_POWER: {enumType: 'windPower', description: '風力', id: 6, unit: '級'},
    GUST: {enumType: 'gust', description: '陣風', id: 7, unit: '級'},
    WAVE: {enumType: 'wave', description: '浪高', id: 8, unit: '公尺'},
    SWELL: {enumType: 'swell', description: '長浪', id: 9, unit: ''},
    EARTHQUAKE: {enumType: 'earthquake', description: '地震', id: 10, unit: '級'},
    TYPHOON: {enumType: 'typhoon', description: '颱風', id: 11, unit: ''},
    HEAVY_RAIN: {enumType: 'heavyRain', description: '豪雨', id: 12, unit: ''},
    WIND_FORECAST_VELOCITY: {enumType: 'windForecastVelocity', description: '風速預報', id: 13, unit: 'm/s'},
    WIND_FORECAST_POWER: {enumType: 'windForecastPower', description: '風力預報', id: 14, unit: '級'},
    WATER_LEVEL: {enumType: 'waterLevel', description: '水位', id: 15, unit: '公尺'},
  }
  //--------- EastCoastMonitor cwb weather end

  //--------- EastCoastMonitor Vehicle And People start
  static HOME_PAGE_VEHICLE_PEOPLE_ITEM = {
    SCENIC_AREA_ID: this.SCENIC_AREA_ID,

    VEHICLE_FLOW_DATA: 'vehicleFlowData',
    TOTALE_VEHICLE_FLOW: 'totalVehicleFlow',
    TOTALE_INSITE_CAR_FLOW: 'totalInSiteCarFlow',
    CAR_TOTALE_FLOW: 'carTotalFlow',
    CAR_INSITE_FLOW: 'carInSiteFlow',
    CAR_PARKING_SPACE: 'carParkingSpace',
    CAR_PARKING_USING_RATIO: 'carParkingUsageRatio',
    BUS_TOTAL_FLOW: 'busTotalFlow',
    BUS_INSITE_FLOW: 'busInSiteFlow',
    BUS_PARKING_SPACE: 'busParkingSpace',
    BUS_PARKING_USING_RATIO: 'busParkingUsageRatio',
    MOTOCYCLE_TOTALE_FLOW: 'motocycleTotalFlow',
    MOTOCYCLE_INSITE_FLOW: 'motocycleInSiteFlow',
    MOTOCYCLE_PARKING_SPACE: 'motocycleParkingSpace',
    MOTOCYCLE_PARKING_USING_RATIO: 'motocycleParkingUsageRatio',
    SMALLBUS_TOTAL_FLOW: 'smallBusTotalFlow',
    SMALLBUS_INSITE_FLOW: 'smallBusInSiteFlow',

    PEOPLE_FLOW_DATA: 'peopleFlowData',
    TOTALE_PEOPLE_FLOW: 'totalPeopleFlow',
    INSIDE_PEOPLE_FLOW: 'inSitePeopleFlow',

    BUS_SERIES: 'busSeries',
    CAR_SERIES: 'carSeries',
    MOTO_SERIES: 'motoSeries',
  }

  //--------- EastCoastMonitor Vehicle And People end

  //--------- EastCoastMonitor trafic flow start
  static TOTAL_TRAFFICFLOW_KEY ={
    COMPACT: 'compact',
    FULL_SIZE: 'fullSize',
    MOTORCYCLE: 'motorcycle',
    PEOPLE_FLOW: 'peopleFlow',
    TRAILER: 'trailer'
  }

  static VD_ENTRANCE_ID = {
    NORTH: 1,
    MIDDLE: 2,
    SOUTH: 3
  }

  static VD_VEHICLE_TYPE_ID = {
    M: 3, //機車
    S: 2, //小型車
    L: 1, //大型車
    T: 4, //聯結車
  }

  static VD_VEHICLE_TYPE_ID_AREA_CAR = {
    M: "motorcycle", //機車
    S: "compact", //小型車
    L: "fullSize", //大型車
    T: "trailer", //聯結車
  }


  static VD_DETECTION_ID = {
    IN: 1,
    OUT: 2
  }

  static VD_DETECTION_ID_AREA_CAR = {
    IN: "in",
    OUT: "out"
  }

  static TRAFFIC_ENTRANCE_ENUM = [
    {enumType: 'North', id: this.VD_ENTRANCE_ID.NORTH, description:'北口', name:'北口'}, //(花蓮大橋、台11線4K)
    {enumType: 'Middle', id: this.VD_ENTRANCE_ID.MIDDLE, description:'中口', name:'中口'}, //(玉長公路、台11線90K)
    {enumType: 'South', id: this.VD_ENTRANCE_ID.SOUTH, description:'南口', name:'南口'}, //(中華大橋、台11線157K)
  ]

  static TRAFFIC_DIRECTION_ENUM = [
    {enumType: 'In', id: this.VD_DETECTION_ID.IN, description:'進入'},
    {enumType: 'Out', id: this.VD_DETECTION_ID.OUT, description:'離開'},
  ]

  static TRAFFIC_VEHICLE_TYPE_ENUM = [
    {enumType: 'M', id: this.VD_VEHICLE_TYPE_ID_AREA_CAR.M, description:'機車'},
    {enumType: 'S', id: this.VD_VEHICLE_TYPE_ID_AREA_CAR.S, description:'小客車'},
    {enumType: 'L', id: this.VD_VEHICLE_TYPE_ID_AREA_CAR.L, description:'大客車'},
    {enumType: 'T', id: this.VD_VEHICLE_TYPE_ID_AREA_CAR.T, description:'聯結車'},
  ]
  //--------- EastCoastMonitor trafic flow end

  //--------- EastCoastMonitor toilet flow start
  static HOME_PAGE_TOILET_FLOW_ITEM = {
    SCENIC_AREA_ID: this.SCENIC_AREA_ID,
    TOILETS: this.TOILETS,

    TOILET_NAME: 'toiletName',
    TOILET_GROUP: 'toiletGroup',
    MALE_FLOW_COUNT:'maleFlowCount',
    FEMALE_FLOW_COUNT: 'femaleFlowCount',
    MULTI_FUNCTIONAL_FLOW_COUNT: 'multiFunctionalFlowCount',
    MIXED_FLOW_COUNT: 'mixedFlowCount',
    FAMILY_FLOW_COUNT: 'familyFlowCount',
  }
  //--------- EastCoastMonitor toilet flow end

  //--------- EastCoastMonitor traffic flow start

  //--------- EastCoastMonitor traffic flow end

  //--------- ToiletMgt start
  static IOT_EQUITMENT_NO_DATA = -1
  static ODOR_CRTICAL_POINT = 30
  static HAND_SANITIZER_CRTICAL_POINT = 1
  static TOILET_MANAGEMENT_ITEM = {
    SCENIC_AREA_ID: this.SCENIC_AREA_ID,
    TOILETS: this.TOILETS,
    PUBLIC_PLACE:this.PUBLIC_PLACE,
    HANDS_ANITIZER_DETECTORS: this.HANDS_ANITIZER_DETECTORS,
    HUMIDITY: this.HUMIDITY,
    NAME: 'name',
    PEOPLE_COUNT: 'peopleCount',
    TEMPERATURE: this.TEMPERATURE,
    ODOR: this.ODOR // 在elk上是odor

  }
  //--------- ToiletMgt end

  //--------- PassengerEstimate start
  static ESTIMATE_KEY = 'estimate'
  static DATE_TYPE_KEY = 'dayType'
  static AVERAGE_NUM_KEY = 'averageNumber'
  static ESTIMATE_DAT_TYPE = {
    ordinaryDay: '平日',
    holiday: '假日'
  }

  static ESTIMATE_CAR_TYPE = {
    motorcycle: '機車',
    fullSize: '大型車',
    compact: '小型車',
    suv: 'suv',
    smallBus: '小巴士',
    truck: '卡車'
  }
  //--------- PassengerEstimate end

  //--------- Violation start
  static VIOLATION_TYPE_ENUM = [
    {enumType: 'Intrude', id: 2, description: '機車闖入'},
    {enumType: 'CloseInAdvance', id: 4, description: '預警封閉'}
  ]

  
  //--------- Violation end

  //--------- control history start
  static CONTROL_TYPE = {
    NONE: 'none',
    WARING: 'earlyWarning',
    CONTROL: 'startContol'
  }
  //--------- control history end

  //---------- Emergency Events  start
  static FILL_ACCOUNT_UNKOWN = '-'
  
  static REASON_ONE = '身體不適';
  static REASON_TWO = '意外受傷';
  static REASON_THREE = '遊客誤觸';
  static REASON_FOUR = '廠商測試';
  static REASON_FOUR_OLDER = '現場測試';
  static REASON_FIVE = '其他';

  // static REASON_ONE = '遊客誤觸'
  // static REASON_TWO = '現場測試'
  // static REASON_THREE = '其他'
  // static REASON_FOUR = '事件說明'

  static SOS_DISSMISS_CONTENT = {
    ALL: '全部',
    MISTAKE: this.REASON_ONE,
    TEST: this.REASON_FOUR,
    TEST_2: this.REASON_FOUR_OLDER,
    UNWELL: this.REASON_THREE,
    INJURY: this.REASON_TWO,
    OTHER: this.REASON_FIVE,

    // ALERT: '警報'
  }

  static SOS_TIME_PERIOD = {
    DAY_TIME: '日間',
    NIGHT: '夜間'
  }
  //---------- Emergency Events  end

  //---------- PeopleAttribute  start
  static PEOPLE_ATTRIBUTE_API_KEY = {
    SCENIC_AREA_ID: this.SCENIC_AREA_ID,
    SCENIC_NAME: this.SCENIC_AREA_NAME,
    START_TIME: 'startTime',
    END_TIME: 'endTime',

    MAN_COUNT: 'manCount',
    MAN_RATIO: 'manRatio',
    WOMAN_COUNT: 'womanCount',
    WOMAN_RATIO: 'womanRatio',

    AGE_0_11: 'age0to11',
    AGE_12_19: 'age12to19',
    AGE_20_29: 'age20to29',
    AGE_30_39: 'age30to39',
    AGE_40_49: 'age40to49',
    AGE_50_59: 'age50to59',
    AGE_60_ABOVE: 'age60above',

    AGE_0_11_RATIO: 'age0to11Ratio',
    AGE_12_19_RATIO: 'age12to19Ratio',
    AGE_20_29_RATIO: 'age20to29Ratio',
    AGE_30_39_RATIO: 'age30to39Ratio',
    AGE_40_49_RATIO: 'age40to49Ratio',
    AGE_50_59_RATIO: 'age50to59Ratio',
    AGE_60_ABOVE_RATIO: 'age60aboveRatio',

    AGE_CHILD: 'age0to15', //孩童
    AGE_ADLUT: 'age16to59', //青壯年
    AGE_ELDER: 'age60above', //銀髮族

    AGE_CHILD_RATIO: 'age0to15Ratio',
    AGE_ADLUT_RATIO: 'age16to59Ratio',
    AGE_ELDER_RATIO: 'age60aboveRatio',
  }

  static GENDER = {
    MALE: '男性',
    FEMALE: '女性'
  }
  static AGE= {
    AGE_0_11: '0-11歲',
    AGE_12_19: '12-19歲',
    AGE_20_29: '20-29歲',
    AGE_30_39: '30-39歲',
    AGE_40_49: '40-49歲',
    AGE_50_59: '50-59歲',
    AGE_60_ABOVE: '60歲以上',
  }

  static AGE_LABEL = {
    AGE_CHILD: '孩童 : 0 - 15 歲以上', 
    AGE_ADLUT: '青壯年 : 16 - 59 歲以上', 
    AGE_ELDER: '銀髮族 : 60 歲以上', 
  }
  static PEOPLE_ATTRIBUTE_TYPE = {
    AGE: 0,
    GENDER: 1
  }
  //---------- PeopleAttribute  end

  //---------- CenterPeopleFlow  start
  static CENTER_PEOPLE_FLOW_API_KEY = {
    SCENIC_AREA_ID: this.SCENIC_AREA_ID,
    SCENIC_NAME: this.SCENIC_AREA_NAME,

    PEOPLE_COME_IN: 'peopleCameIn',
    PEOPLE_COME_OUT: 'peopleCameOut',
    PEOPLE_INSITE: 'peopleInsite'
  }

  static PEOPLE_IN_OUT_TYPE = {
    NONE: -1,
    IN: 0,
    OUT: 1
  }

  static PEOPLE_IN_OUT = {
    IN: '進場',
    OUT: '離場'
  }
  //---------- CenterPeopleFlow  end

  //------Activity start
  static ACTIVITY_STATUS = {
    WILL: "WILL",
    DURING: "DURING",
    END: "END"
  }
  //------Activity end
  static APEXCHART_COLOR = {
    SCENIC_AREA:["#5db2fa","#92cc77","#fac859","#ee6666", "#a6a2ff","#4e9faf","#ff76b1","#3ee9c3","#7b5cf6"],
    LINE_CHART_RANGE:["#5db2fa","#92cc77","#ffa94e","#ff7676"], 
    LINE_CHART_RANGE_FIVE:["#748acf","#91cc75","#fabf58","#73c0de","#f28188"], 
    DEVICE_ERROR_STATISTIC:["#5db2fa","#92cc77","#fac859","#ee6666", "#a6a2ff","#4e9faf","#ff76b1","#a97d7d"],


 
  }


  //--------------ParkingLimit Type

  static PARKING_AREA_STATUS = [
    {enumType: 'All', id: "", status: ["green","yellow","red"], description: '全部'},
    {enumType: 'Normal', id: 0, status: ["green"], description: '無警戒'},
    {enumType: 'Alert', id: [1,2], status: ["yellow","red"], description: '警戒'},


  ]
    
   //---------- HumanSensor  start
   static HUMAN_SENSOR_TYPE ={
    FLOOR:['1F','2F'],
    GENDER_MALE:'male',
    GENDER_FEMALE:'female',
    GENDER_OTHER:'accessible', //無障礙
    CATEGORY_SIT:'sit', //坐式
    CATEGORY_SQUAT:'squat', // 蹲式
  }

  static HUMAN_SENSOR_MONITOR_TEXT =[
    {
      TAIWANESE:"鄰近廁所請至旁邊樓梯上樓左側",
      ENGLISH:"Please go up the stairs to the left side of the toilet",
      JAPANESE:"トイレの左側の階段を上ってください",
      KOREAN:"화장실 왼쪽 계단으로 올라가주세요",
    },
    {
      TAIWANESE:"鄰近廁所請至旁邊樓梯下樓右側",
      ENGLISH:"Please go down the stairs to the right side of the toilet.",
      JAPANESE:"トイレの右側にある階段を降りてください。",
      KOREAN:"화장실 오른쪽 계단으로 내려가세요.",
    }
  ]
  
 }
